import React from 'react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Login/Login.css';
import { useDispatch, useSelector } from 'react-redux';
import CONSTANTS from '../util/constants';
import Encrypt from '../util/encrypt';
import APICallingService from '../services/APICallingService';


const Login = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const email = useSelector((state) => state.login.email);
    const emailError = useSelector((state) => state.login.emailError);
    const password = useSelector((state) => state.login.password);
    const loginResponse = useSelector((state) => state.login.loginResponse);
    const loginRolesData = useSelector((state) => state.login.loginRolesData);
    let location = useLocation();

    const [userRoles, setUserRoles] = useState([]);

    const onFocus = () => {
        dispatch({
            type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL, payload: { value: "" }
        })
        dispatch({
            type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD, payload: { value: "" }
        })
    }

    useEffect(() => {
        window.addEventListener("focus", onFocus);
        onFocus();
        return () => {
            window.removeEventListener("focus", onFocus);
        };
    }, []);

    useEffect(() => {
        APICallingService.navigate = navigate;
        APICallingService.loginAlert = false;
        if (loginResponse && loginResponse != null && loginResponse != 'Failed') {

            let localstorageLR = localStorage.getItem("L_R");
            let data = localstorageLR ? JSON.parse(Encrypt.dycryptData(localstorageLR)) : '';
            let loginResponseRoles = localstorageLR ? ((data) != "" || (data) != null) ? data?.user?.userRoles : [] : [];

            if ((loginResponseRoles && loginResponseRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN) || (loginRolesData[0]?.user_role_id == CONSTANTS.CONSTANTS_USER_ROLES.VIEWONLY)) {
                navigate('DashboardAdmin');
            }
            else {
                dispatch({
                    type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.DIVISION_SELECTED, payload: { value: { label: loginResponse?.user?.division?.divisionName, value: loginResponse?.user?.division?.division_id } }
                })
                navigate('/Dashboard', { state: { dc_selected: loginResponse?.user?.division } });

            }
        }

    }, [loginResponse]);

    useEffect(() => {
        if (loginResponse && loginResponse != 'Failed') {
            dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_ROLES_MANAGEMENT_API_CALL
            });
        }
    }, [loginResponse]);

    const changeEmail = (e) => {
        const val = e.target.value;
        const emailRegx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL, payload: { value: val } })
        dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_EMAIL_ERROR, payload: { value: false } })

    }

    const changePassword = (e) => {

        const val = e.target.value;
        if (val == null || val == '') {
            dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD, payload: { value: '' } });
            dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_PASSWORD_ERROR, payload: { value: true } })
        }
        else {

            dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD, payload: { value: val } })

        }
    }

    const loginClick = () => {
        if (email == '' || password == '') {
            alert('Please enter the Login Details')
        }
        else if (emailError) {
            alert('Please enter valid email');
        }
        else {
            const loginPayload = {
                email: email,
                password: password
            }
            dispatch({ type: CONSTANTS.CONSTANTS_LOGIN.CALL_LOGIN_API, payload: { value: loginPayload } })

        }
    }

    return (
        <section>
            <div className="page-header col-md-12 tabmargin tab-center" style={{
                position: 'absolute', left: '50%', top: '30%',
                transform: 'translate(-50%, -50%)', height: '60% !important'
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-3" style={{ height: '100%' }} />
                        <div className="col-md-6 col-6" style={{ height: '100%' }}>
                            <div className="card card-plain mt-12" >
                                <div className="card-header text-center pt-0 px-lg-2 px-1">
                                    <img src={require("./../assets/Dashboard/BurtonLogisticsLogo-DarkGray-small.png")} className="navbar-brand-img" />
                                </div>
                                <div className="card-body" style={{ border: '1HN FbFFRT4solid black !important' }}>
                                    <form role="form">
                                        <label>Email</label>
                                        <div className="mb-3">
                                            <input type="email" className="form-control" placeholder="Email" aria-label="Email" aria-describedby="email-addon" maxLength={50} onChange={changeEmail} value={email}

                                            />
                                        </div>
                                        <label>Password</label>
                                        <div className="mb-3">
                                            <input type="password" className="form-control" placeholder="Password" aria-label="Password" maxLength={30} aria-describedby="password-addon" onChange={changePassword} value={password}
                                            />
                                        </div>

                                        <div
                                            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%', marginBottom: 12 }}
                                            onClick={() => {
                                                navigate('/ForgotPassword');
                                            }}
                                        >
                                            <a href='' style={{ textDecoration: 'underline' }}>Forgot Password?</a>
                                        </div>

                                        <div className="text-center" >
                                            <button type="button" className="btn col-md-4" style={{ borderRadius: 4, borderColor: '#17a2b8', color: 'white', background: "linear-gradient(300deg,#2152ff,#21d4fd)" }} onClick={() => { loginClick() }}>Sign in</button>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 col-3" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Login;